import { render, staticRenderFns } from "./CzFooter.vue?vue&type=template&id=b2d754dc&scoped=true&"
import script from "./CzFooter.vue?vue&type=script&lang=js&"
export * from "./CzFooter.vue?vue&type=script&lang=js&"
import style0 from "./CzFooter.vue?vue&type=style&index=0&id=b2d754dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d754dc",
  null
  
)

export default component.exports